// removed by extract-text-webpack-plugin
module.exports = {"loadingScreen":"styles__loadingScreen__6LKXn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoadingScreen/styles.less
// module id = 287
// module chunks = 0